/**
 * Created by Jerker Nord on 2020-05-26.
 */
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {MonkeysGoldLogo} from "../../logo/MonkeysGoldLogo";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TimelineLite} from "gsap";

export class MonkeysGoldFreeSpinOutroController extends FreespinOutroController {

    private _isBigWin:boolean;

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        this._isBigWin = (<ParsedGameData>data).isBigWin;
        if(data.freespinsLeft == 0 && (data.mode == GameMode.FREESPIN || data.mode == GameMode.FREESPIN_AVALANCHE) && data.nextMode == GameMode.NORMAL) {
            return true;
        } else {
            return false;
        }
    }

    public start():void {
        //If FS ends with a Big Win we need a short delay to show Total Win
        if(this._isBigWin == true) {
            const delayTL:TimelineLite = new TimelineLite();
            delayTL.add(() => super.start(), "+=2");
        } else {
            super.start();
        }
    }

    protected close():void {
        (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.CONTINUE_BUTTON)});
        super.close();
    }

    public static actuallyDoTransition() {
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : GameMode.NORMAL}));
        MonkeysGoldGameModuleConfig.monkeysGoldBonusGameMultiplierView.disableMultplier();
        MonkeysGoldLogo.monkeysGoldLogo.enableMainGameLogo();
        MonkeysGoldGameModuleConfig.monkeysGoldReelAreaView.enableMainGameBackgroundGFX();
        MonkeysGoldGameModuleConfig.monkeysGoldAllReelsFilledWinView.restoreDice();
        this.resetAllSymbols();
    }

    private static resetAllSymbols():void {
        for(let i:number = 0; i < 6; i++) {
            let symbolsOnReel:StateReelSymbol[] = Reels.getReel(i)!.allSymbols;
            for(let j:number = 0; j < symbolsOnReel.length; j++) {
                symbolsOnReel[j].changeState({state : GameConfig.instance.SYMBOL_STATES.normal});
            }
        }
    }
}